import React from "react";
import { filterStateConfigs } from "./configs";
import ChrTooltip from "../Form/Basic/ChrTooltip";
import { keyBoardAccessibilityAttributes } from "../../../utils/GeneralUtils";

const FilterHeader = props => {
  const {
    title,
    value,
    showBody,
    onClickHandler,
    disabled,
    invalid,
    removable,
    dropDownIcon,
    onRemoveHandler,
    filterCount,
    buttonSize,
    rounded = false,
    suffixConstructor,
    filterHeaderFontStyleClass,
    noShadow = false,
    newUx = false
  } = props;

  const {
    fixedWidth,
    fixedWidthClass = "custom-width-12",
    widthClass = "custom-max-width-12",
  } = props;

  const computedWidthClass = fixedWidth ? fixedWidthClass : widthClass;

  let filterData;
  let filterTooltip;

  if (typeof title === 'string') {
    filterData = title;
    if (value) filterData = `${filterData}: ${value}`;
    filterTooltip = filterData;
  } else {
    filterData = (
      <div className="d-flex flex-row">
        <div className="mr-2">{ title }</div>
        { value && <div>{ value }</div> }
      </div>
    )
  }

  const getTypeAndTooltip = () => {
    let configs = {};
    if (disabled)
      configs = filterStateConfigs.disabled;
    else if(invalid)
      configs = filterStateConfigs.invalid;

    return {
      type: configs.type,
      tooltip: (
        configs.showTooltip && <ChrTooltip
          content={ props[`${configs.name}Tooltip`] }
          iconClass={ `fa-solid fa-exclamation-circle align-self-center text-${configs.type}` }
        />
      )
    };
  };

  const {type, tooltip} = getTypeAndTooltip();
  const wrapperClass = type ? `thick-border border border-${type}` : "";
  const roundedClass = rounded ? "btn-rounded-5" : ""

  const dataClass = disabled ? "text-muted" : showBody ? "font-600" : "";
  const buttonSizeClass = buttonSize ? `btn-${buttonSize}` : '';
  const shadowClass = noShadow ? '' : 'shadow-sm';

  return (
    <div className={ `${newUx ? '' : 'cui-border-gray'} ${wrapperClass} ${shadowClass} ${computedWidthClass} dropdown ${roundedClass}` }>
      <div
        className={ `btn ${buttonSizeClass} btn-white shadow-sm waves-effect ${newUx ? '' : 'no-borders'} d-flex ${roundedClass}` }
        title={ filterTooltip }
        onClick={ onClickHandler }
        { ...keyBoardAccessibilityAttributes }
      >
        <div className={ `text-truncate mr-auto ${dataClass} ${filterHeaderFontStyleClass}` }>
          { filterData }
        </div>
        {
          // TODO_CONNECTION_VIEWS : Check with Ranjith
          filterCount && filterCount > 0 ? <div className={ "badge badge-pill badge-info align-self-end mx-1" }>{ filterCount }</div> : null
        }
        { dropDownIcon && <i className={"fa-solid fa-caret-down ml-2 align-self-center"} /> }
        { tooltip }
        { suffixConstructor && suffixConstructor() }
        {
          removable && <i
            className={ "fa-regular fa-xmark pl-1 align-self-center" }
            onClick={ onRemoveHandler } />
        }
      </div >
    </div >
  );
};

export default FilterHeader;
